export default "__VITE_ASSET__DePnVSSr__"